import React, { PureComponent } from 'react';
import CalendarView from './calendarView';
import Subtitle from '../text/subtitle';
import { Col } from 'styled-bootstrap-grid';

// Components
import { ListView } from './listView';

class DisplayView extends PureComponent {
  render(props) {
    let displayView;

    if (this.props.activeView === 'List') {
      if (this.props.filteredEvents.length >= 1) {
        displayView = (
          <ListView
            allEvents={this.props.filteredEvents}
            color={this.props.theme.highlightColor}
            textColor={this.props.theme.textColor}
          />
        );
      } else if (this.props.filteredEvents.length === 0) {
        displayView = (
          <Col col={12}>
            <Subtitle text={'Sorry your search returned 0 results'} />
          </Col>
        );
      }
    } else if (this.props.activeView === 'Calendar') {
      displayView = <CalendarView events={this.props.filteredEvents} />;
    }
    return <>{displayView}</>;
  }
}

export default DisplayView;
